import {createSystem, defaultConfig, defineConfig, mergeConfigs} from "@chakra-ui/react";

const config = defineConfig({
    globalCss: {
        html: {
            backgroundColor: '#d4d4d8',
            color: "black",
        },
    }})

const merge = mergeConfigs(defaultConfig, config)
export const system = createSystem(merge)
